module.exports = __webpack_public_path__ + "img/legend-pay-logo-dark.0e4e88ad.svg";